import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import { Card, Row, Col,Popover } from 'antd';
import { QuestionCircleOutlined ,DownloadOutlined} from '@ant-design/icons';
import ReactECharts from 'echarts-for-react';
import help from '../../config/help.json';
import { CSVLink } from 'react-csv';

import './analytics.css';


var cc_data;
// var cc_data1;

// const countriesInfo = Object.keys(countrycodeLatlong).map(code =>({code, lat:countrycodeLatlong[code][0], long:countrycodeLatlong[code][1], name: countries[code.toUpperCase()]}))

class ActiveUsersCard extends Component {
	constructor(props) {
		super(props);
		this.state = {
		 }
	}

	async componentDidUpdate(prevProps) {
	}


	render() {
		// const { opensearchDailyActiveUserList, loading, userTheme,opensearchActiveUserTotalList } = this.props;
		const { opensearchDailyActiveUserList, loading, userTheme } = this.props;

		cc_data = opensearchDailyActiveUserList || [];
		cc_data = cc_data.sort((a,b)=>a.key-b.key);
		//cc_data1 = opensearchActiveUserTotalList || {};

		let userid = 0;
		if(cc_data){
			cc_data.forEach(d => {
				if(d && d.userid && d.userid.value){
					userid += d.userid.value
				}
				
			})
		}
		// if(cc_data1 && cc_data1.userid && cc_data1.userid.value){
		// 	userid = cc_data1.userid.value;
		// }
		// let userip = 0;
		// if(cc_data1 && cc_data1.userip && cc_data1.userip.value){
		// 	userip = cc_data1.userip.value;
		// }
		// let devicesno = 0;
		// if(cc_data1 && cc_data1.devicesno && cc_data1.devicesno.value){
		// 	devicesno = cc_data1.devicesno.value;
		// }
		

		const option = {
		  tooltip: {
			trigger: 'axis',
			axisPointer: {
			  type: 'shadow'
			},
			formatter: function (data) {
									data = data[0];
									return `Active registered DAU: ${cc_data[data.dataIndex].userid.value} @ ${moment(cc_data[data.dataIndex].key_as_string).format("MMM-DD")}<br>
									Active registered DAU (Total): ${userid}<br>
									`
									// return `Active registered DAU: ${cc_data[data.dataIndex].userid.value}, ${Math.round(cc_data[data.dataIndex].userid.value/userid*10000)/100}%, @ ${moment(cc_data[data.dataIndex].key_as_string).format("MMM-DD")}<br>
									// Active guest DAU: ${cc_data[data.dataIndex].userip.value - cc_data[data.dataIndex].userid.value}, ${Math.round((cc_data[data.dataIndex].userip.value - cc_data[data.dataIndex].userid.value)/ (userip - userid)*10000)/100}%, @ ${moment(cc_data[data.dataIndex].key_as_string).format("MMM-DD")}<br>
									// Active registered DAU (Total): ${userid}<br>
									// Active guest DAU (Total): ${userip - userid}
									// `
								},//By device sno: ${cc_data[data.dataIndex].devicesno.value}, ${Math.round(cc_data[data.dataIndex].devicesno.value/devicesno*10000)/100}%, @ ${moment(cc_data[data.dataIndex].key_as_string).format("MMM-DD")}<br>
		  },
		  legend: {
			data: ['Daily Active User', 'by user id', 'by user ip']
		  },
		//   toolbox: {
		// 	showTitle: false,
		// 	feature: {
		// 		mark: { show: true },
		// 		dataView: { show: true, readOnly: false, lang:['Data View', 'Close', 'Refresh'],title:'Data View' },
		// 		magicType: { show: true, type: ['line', 'bar', 'stack'],title:{line:'Line Chart', bar:'Bar Chart',stack:'Stack Chart',tiled:'Tiled Chart' }},
		// 		restore: { show: true, title:'Refresh' },
				
		// 	  }
		//   },
		  xAxis: [
			{
			  type: 'category',
			  axisTick: { show: false },
			  data: cc_data.map(d=>d.key_as_string),
			  axisLabel: {
				//interval: 1,
				formatter: function (timestamp) {
					return moment(timestamp).format("MMM-DD");
				}
				}
			}
		  ],
		  yAxis: [
			{
			  type: 'value'
			}
		  ],
		  series: [
			// {
			//   name: 'by device sno',
			//   type: 'bar',
			//   barGap: 0.1,
			  
			//   emphasis: {
			// 	focus: 'series'
			//   },
			  
			//   data: cc_data.map(d=>d.devicesno.value)
			// },
			{
			  name: 'Daily Active User',
			  type: 'bar',
			  
			  emphasis: {
				focus: 'series'
			  },
			  data: cc_data.map(d=>d.userid.value)
			},
			// {
			//   name: 'Active Guest User',
			//   type: 'bar',
			  
			//   emphasis: {
			// 	focus: 'series'
			//   },
			//   data: cc_data.map(d=>d.userip.value - d.userid.value)
			// }
		  ]
		};
		// const options = {
		// 			backgroundColor: (userTheme === 'dark')?"#00000080":"#FFFFFF80",
		// 			grid: {
		// 				top: '10%',
		// 		    left: '2%',
		// 		    right: '2%',
		// 		    bottom: '0%',
		// 				containLabel: true },
		// 			xAxis: {
		// 				type: 'category',
		// 				data: cc_data.map(d=>d.key_as_string),
		// 				axisTick: {
		// 					show: false
		// 				},
		// 				axisLabel: {
		// 					interval: 7,
		// 					formatter: function (timestamp) {
		// 						return moment(timestamp).format("MMM-DD");
		// 					}
		// 				},
		// 				axisLine: {
		// 					lineStyle: {
		// 						type: 'solid'
		// 					}
		// 				}
		// 			},
		// 		  yAxis: {
		// 		    type: 'value',
		// 	      splitArea: {
		// 	        show: true
		// 	      },
		// 				axisLine: {
		// 					lineStyle: {
		// 						type: 'solid'
		// 					}
		// 				}
		// 		  }
		// 		};

		// let options1 = Object.assign({}, options, {
		// 	    tooltip: {
		// 	      trigger: 'axis',
		// 				formatter: function (data) {
		// 					data = data[0];
		// 					return `Active User:<br> ${cc_data[data.dataIndex].activeusers.value} @ ${moment(cc_data[data.dataIndex].key_as_string).format("MMM-DD")} `
		// 				},
		// 				rich: {}
		// 	    },
		// 		  series: [
		// 		    {
		// 		      data: cc_data.map(d=>d.activeusers.value),
		// 		      type: 'line',
		// 					color: '#096dd9',
        // 			showSymbol: false
		// 		    }
		// 		  ]
		// 		});

		return (
      <Card className="analyticCard analyticActiveUsersCard">
				<h3 className="title">{`Active Users  `}
					<Popover placement="topLeft"
						overlayStyle={{width:'300px'}}
						content= {help.find(d=> d.name ==='ActiveUsersCard').en}
						trigger="click"><QuestionCircleOutlined />
					</Popover>
					<CSVLink data={cc_data.map(c => ({ date: moment(c.key_as_string).format("MMM-DD"), count: c.userid.value }))} target="_blank" filename={"Active Users.csv"}>
						<DownloadOutlined />
					</CSVLink>
				</h3>
				<Row>
				 <Col span={24}>
				 	<ReactECharts style={{ height: 320, width: '100%' }} theme={userTheme} option={option} notMerge={true} showLoading={loading} loadingOption={{color:"#74add1"}} />
				</Col>
 				</Row>
     </Card>
		);
	}


}

const mapStateToProps = state => ({
	router: state.router,
	userTheme: state.user.userTheme,
	opensearchDailyActiveUserList: state.analytics.opensearchDailyActiveUserList,
	selectedOrganization: state.user.selectedOrganization,
	opensearchActiveUserTotalList: state.analytics.opensearchActiveUserTotalList
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
		},
		dispatch
	);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ActiveUsersCard));
